import TimelineItem from '@/components/TimelineItem';
import { type ITimelineItem } from '@/types/INote';
import styles from './index.module.scss';

export default function Timeline ({
  items,
  onItemClick,
}: {
  items: ITimelineItem[];
  onItemClick: (id: string) => Promise<void> | void;
}) {
  return (
    <div className={styles['timeline']} data-e='notes-importants'>
      <div className={styles['timeline__title']}>Najważniejsze</div>
      <ul className={styles['timeline__list']}>
        {items.map((note: ITimelineItem) => (
          <TimelineItem
            data={note}
            key={`timeline-${note.id}-${note._updateTimestamp || 0}`}
            onClick={onItemClick}
          />
        ))}
      </ul>
    </div>
  );
}
